// Show more text on education page functions
var moreButton = document.querySelector('.education-text .read-more')
var openDoc = document.querySelector('.education-text .text-content')
var lessButton = document.querySelector('.education-text .read-less')

if (moreButton){
  moreButton.addEventListener('click', function() {
    openDoc.classList.toggle('open')
    lessButton.classList.toggle('show')  
    moreButton.classList.toggle('hide')  
  });

  lessButton.addEventListener('click', function() {
    openDoc.classList.toggle('open')
    lessButton.classList.toggle('show')  
    moreButton.classList.toggle('hide')  
  });
}